'use strict';
// @flow
interface User {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export default class SettingsController {
  user: User = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  errors = {other: undefined};
  message = '';
  submitted = false;

  /*@ngInject*/
  constructor(private Auth) {
  }

  changePassword(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.changePassword(this.user.oldPassword, this.user.newPassword)
        .then(() => {
          this.message = 'LBL_INFO_PASSWORD_CHANGED';
          form.$setPristine();
          this.user = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
          };
        })
        .catch(() => {
          form.oldPassword.$setValidity('mongoose', false);
          this.errors.other = 'ERROR_INCORRECT_PASSWORD';
          this.message = '';
        });
    }
  }
  validateField(form, name) {
    return {
      fieldRequired: form.$submitted && form[name].$error.required && form[name].$pristine,
      fieldInvalid: !form[name].$pristine && form[name].$invalid
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/account/settings/settings.controller.ts